import { EraserIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Eraser = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <EraserIcon size={Sizes[size]} {...rest} color={fill} />;
};

Eraser.displayName = 'Eraser';
